import React, { forwardRef } from 'react';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import { useState } from 'react';

const TopTab = forwardRef(({ className = '' }, ref) => {
  const [isWorkflow, setIsWorkFlow] = useState(false)
  return (
    <div
      ref={ref}
      className={[
        'flex-shrink-0 flex items-center h-22px select-none ml-2px',
        className,
      ]}
      style={{
        display: globalStore.isAgentPage() ? "" : "none"
      }}
    >
      {agentPageStore.agentList.map((item, index) => {
        const isCur = agentPageStore.taIndex == index;
        if (item.category == 'example') return null;
        return (
          <div
            key={index}
            onClick={evt => {
              //globalStore.navigate('/tools/aiagent');
              setTimeout(() => {
                let target = document
                .querySelectorAll('.list-item-magic')
                [index]

                if(index == 0 && target) {
                  target = target.parentNode
                }

               target.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }, 20);
            }}
            className={[
              'relative h-22px vh-center mr-24px text-black cursor-pointer whitespace-nowrap',
              isCur
                ? 'font-bold text-16px' // transform scale-112
                : 'text-14px',
            ]}
          >
            {item.title}
            <div
              className={[
                'w-24px h-4px bg-black absolute -bottom-8px transform left-1/2 -translate-x-1/2 rounded-full',
                isCur ? '' : 'hidden',
              ]}
            ></div>
          </div>
        );
      })}
      {/* <div 
        onClick={evt => {
          //globalStore.navigate('/tools/aiagent');
          setTimeout(() => {
            
            const index = document
            .querySelectorAll('.list-item-magic').length - 1
            console.log("index is", index)
            let target = document
            .querySelectorAll('.list-item-magic')
            [index]

            if(index == 1 && target) {
              target = target.parentNode
            }

            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }, 20);
        }}
        className={[
        'relative h-22px vh-center mr-24px text-black cursor-pointer whitespace-nowrap',
        isWorkflow
          ? 'font-bold text-16px' // transform scale-112
          : 'text-14px',
      ]}>
        工作流
        <div
          className={[
            'w-24px h-4px bg-black absolute -bottom-8px transform left-1/2 -translate-x-1/2 rounded-full',
            isWorkflow ? '' : 'hidden',
          ]}
        ></div>
      </div> */}
    </div>
  );
});

export default observer(TopTab);
